const initialValue = {
  data: [],
  error: "",
};

const HowItsWorksReducer = (state = initialValue, action) => {
  switch (action.type) {
    case "HOW_ITS_WORKS_SUCCESS":
      return {
        ...state,
        data: action.payload,
        error: "",
      };
    case "HOW_ITS_WORKS_FAILURE":
      return {
        ...state,
        data: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

export default HowItsWorksReducer;
